/**
 * Utility functions for handling navigation paths with proper base URL
 */

/**
 * Get the correct login path with base URL
 * @returns {string} The full login path including base URL
 */
export const getLoginPath = () => {
    // Try to get BASE_URL from environment, fallback to hardcoded value
    const baseUrl = import.meta.env.BASE_URL || '/ClientFileUploadPortal/';
    return `${baseUrl}login`;
};

/**
 * Get the base URL for the application
 * @returns {string} The base URL
 */
export const getBaseUrl = () => {
    return import.meta.env.BASE_URL || '/ClientFileUploadPortal/';
};

/**
 * Navigate to login page using window.location (for situations where React Router isn't available)
 * @param {string} reason - Optional reason for logging
 */
export const redirectToLogin = (reason = 'unauthorized') => {
    const loginPath = getLoginPath();
    console.log(`Redirecting to login (${reason}):`, loginPath);
    window.location.href = loginPath;
};

/**
 * Check if current path is the login path
 * @returns {boolean} True if on login page
 */
export const isOnLoginPage = () => {
    const loginPath = getLoginPath();
    const currentPath = window.location.pathname;
    return (
        currentPath === loginPath ||
        currentPath.endsWith('/login') ||
        currentPath.endsWith('/login/callback')
    );
};
